module.exports = {"providers":[],"isHerokuEnabled":true};